import { SAGA_ACTIONS } from "../../constants";
import { useApiCall } from "../common/appApiCallHook";

/** QuickBooks incremental re-sync API (gl-api /qb-sync), QuickBooks Online and Desktop. */
export function useQbSyncApi() {
    const callApi = useApiCall();
    const A = SAGA_ACTIONS.QB_SYNC;

    return {
        getStatus: (branchId: number, onSuccess: Function, onError: Function) =>
            callApi(A.STATUS, { branch_id: branchId }, onSuccess, onError),
        saveSettings: (body: { branch_id: number; go_live_month?: string | null; books_closed_through?: string | null },
                       onSuccess: Function, onError: Function) =>
            callApi(A.SETTINGS, body, onSuccess, onError),
        startSession: (body: { branch_id: number; sync_through: string; reconciled_confirmed: boolean },
                       onSuccess: Function, onError: Function) =>
            callApi(A.START, body, onSuccess, onError),
        getSession: (sessionId: number, onSuccess: Function, onError: Function) =>
            callApi(A.SESSION, { sessionId }, onSuccess, onError),
        getChanges: (sessionId: number, month: string | null, onSuccess: Function, onError: Function) =>
            callApi(A.CHANGES, { sessionId, month }, onSuccess, onError),
        setMonths: (sessionId: number, months: { month: string; selected: boolean }[],
                    onSuccess: Function, onError: Function) =>
            callApi(A.MONTHS, { sessionId, months }, onSuccess, onError),
        applySession: (sessionId: number, onSuccess: Function, onError: Function) =>
            callApi(A.APPLY, { sessionId }, onSuccess, onError),
        cancelSession: (sessionId: number, onSuccess: Function, onError: Function) =>
            callApi(A.CANCEL, { sessionId }, onSuccess, onError),
    };
}
